import React from 'react';
import Image from '../Image';
import ButtonLink from '../interface/ButtonLink';
import { Card, Title, ImageWrapper, Subtitle, InfoWrapper } from './VerticalCard.styles';

const VerticalCard = ({ image, title, subtitle, cta, ctaUrl, className }) => {
  return (
    <Card className={className}>
      <ImageWrapper>
        <Image image={image?.[0]} />
      </ImageWrapper>
      {title && (
        <InfoWrapper>
          <Title className="text">{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </InfoWrapper>
      )}

      {ctaUrl && (
        <ButtonLink href={ctaUrl.url} type={ctaUrl.type} color="white" size="half">
          {cta}
        </ButtonLink>
      )}
    </Card>
  );
};

export default VerticalCard;
